import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { EventTypeSelectPopup } from 'components/event_type_select_popup'
import { BOOK_MODAL_SOURCE, openBookModal, trackTelemetryId } from 'features/book_modal'
import { useTrack } from 'hooks/analytics_events'

import { trackScheduleInRealTimeEvent, trackFlowStepCompleted } from '../analytics'

export const ScheduleWithAContactProvider = ({
  isFlowStarted,
  onFlowFinish,
  contact,
  parentSource = null,
  shouldTrackCRMEvent = false,
  shouldTrackContactCardEvent = false,
  shouldTrackContactPageEvent = false
}) => {
  const dispatch = useDispatch()
  const track = useTrack()

  const onConfirm = useCallback((eventType) => {
    onFlowFinish()
    const contactUuid = contact?.uuid ?? contact?.id
    let source = null
    if (shouldTrackContactCardEvent) source = 'contact_hover_card'
    else if (shouldTrackContactPageEvent) source = 'contact_details_page_header'

    trackScheduleInRealTimeEvent({
      contactUuid,
      source,
      step: 'select_et',
      track
    })

    if (shouldTrackCRMEvent) {
      trackFlowStepCompleted({ track, flowLocation: 'contacts_page_right_rail_header' })
    }

    if (shouldTrackContactCardEvent) {
      trackFlowStepCompleted({ track, flowLocation: 'contact_hover_card' })
    }

    if (shouldTrackContactPageEvent) {
      trackFlowStepCompleted({ track, flowLocation: 'contact_details_page_header' })
    }

    dispatch(trackTelemetryId({ source: source || 'contacts_page' }))
    dispatch(openBookModal({
      eventTypeId: eventType.id,
      eventTypeUuid: eventType.uuid,
      eventTypeType: eventType.type,
      eventTypeOwnerType: eventType.owner_type,
      eventTypeOwnerId: eventType.owner_id,
      inviteeName: contact?.name,
      inviteeEmail: contact?.email,
      inviteeTimezone: contact?.timeZone,
      inviteePhone: contact?.phone || contact?.phoneNumber,
      inviteeContactUuid: contactUuid,
      contactsBookingFlow: true,
      ...(parentSource && { source: BOOK_MODAL_SOURCE[parentSource].toLowerCase() })
    }))
  }, [
    contact,
    dispatch,
    parentSource,
    onFlowFinish,
    shouldTrackCRMEvent,
    shouldTrackContactCardEvent,
    shouldTrackContactPageEvent,
    track
  ])

  return (
    <EventTypeSelectPopup
      contact={contact}
      isOpen={isFlowStarted}
      onCancel={onFlowFinish}
      onEventTypeSelect={onConfirm}
      actionKind="book_meeting"
    />
  )
}
